var map = {
	"./labmem_text_language_en.png": "a0ec",
	"./labmem_text_language_jp.png": "8adf",
	"./labmem_text_language_kr.png": "980f",
	"./labmem_text_language_sc.png": "5b00",
	"./labmem_text_language_tc.png": "5c8c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ed36";